/**
 * @file    HistoryPage.css
 *
 *          Stylesheet for the HistoryPage component.
 *
 * @author  Kevin Yu <kevin@distributive.network>
 * @date    March 2024
 */
.history-page {
  grid-template-columns: 3fr 1fr;
  display: grid;
  grid-gap: 0 40px;
  margin-right: 0;
  max-width: 2500px;
  width: 100%;
}

.history-page-content {
  width: 100%;
  overflow-x: hidden;
}

.history-page #bank-operations-tab {
  margin-top: 3rem;
}

@media only screen and (max-width: 1600px) {
  .history-page {
    display: flex;
    flex-wrap: wrap;
  }

  .history-page-content {
    overflow-x: auto;
  }

  .history-page #bank-operations-tab {
    margin: 2em 0;
  }
}